import { z } from 'zod';
/**
 * Реквизиты экспедитора — singleton-запись `ExpeditorProfile` (id=1).
 *
 * Используется и для GET-ответа, и для PUT-запроса. Все поля nullable —
 * система должна работать без заполненных реквизитов (например, до того
 * как ADMIN их заполнил). Пустые строки в форме → null до валидации.
 */
/** Пустая строка / null / whitespace → null; иначе trim. */
const trimmedOrNull = z.preprocess((v) => {
    if (v === null || v === undefined)
        return null;
    if (typeof v !== 'string')
        return v;
    const t = v.trim();
    return t === '' ? null : t;
}, z.string().nullable());
const optionalDigits = (length, label) => z.preprocess((v) => {
    if (v === null || v === undefined)
        return null;
    if (typeof v !== 'string')
        return v;
    const t = v.trim();
    return t === '' ? null : t;
}, z
    .string()
    .regex(new RegExp(`^\\d{${length}}$`), `${label} должен содержать ${length} цифр`)
    .nullable());
const optionalDigitsRange = (min, max, label) => z.preprocess((v) => {
    if (v === null || v === undefined)
        return null;
    if (typeof v !== 'string')
        return v;
    const t = v.trim();
    return t === '' ? null : t;
}, z
    .string()
    .regex(new RegExp(`^\\d{${min},${max}}$`), `${label} должен содержать от ${min} до ${max} цифр`)
    .nullable());
const optionalEmail = z.preprocess((v) => {
    if (v === null || v === undefined)
        return null;
    if (typeof v !== 'string')
        return v;
    const t = v.trim();
    return t === '' ? null : t;
}, z.string().email('Некорректный email').nullable());
export const expeditorProfileSchema = z.object({
    fullName: trimmedOrNull,
    shortName: trimmedOrNull,
    inn: optionalDigitsRange(10, 12, 'ИНН'),
    ogrn: optionalDigitsRange(13, 15, 'ОГРН'),
    kpp: optionalDigits(9, 'КПП'),
    legalAddress: trimmedOrNull,
    postalAddress: trimmedOrNull,
    contactEmail: optionalEmail,
    contactPhone: trimmedOrNull,
    directorName: trimmedOrNull,
    directorPosition: trimmedOrNull,
    bankName: trimmedOrNull,
    bankBik: optionalDigits(9, 'БИК'),
    bankCorrAccount: optionalDigits(20, 'Корр.счёт'),
    bankAccount: optionalDigits(20, 'Расчётный счёт'),
    /** Код абонента ЭДО.МИГ24 — свободная строка (формат зависит от оператора). */
    edoSubscriberId: trimmedOrNull,
    /**
     * ЭТрН оформляется на один контейнер. При включении создание ЭТрН из
     * поручения с несколькими контейнерами требует выбрать один; его данные
     * попадают в ЭТрН, а номер ЭТрН = номер контейнера без букв. Выставляет админ.
     */
    etrnOneContainerPerDoc: z.boolean().default(false),
});
/** Расширенный ответ GET — со служебными полями. */
export const expeditorProfileDtoSchema = expeditorProfileSchema.and(z.object({
    updatedAt: z.string().datetime().nullable(),
    updatedByUserEmail: z.string().nullable(),
}));
//# sourceMappingURL=expeditor-profile.js.map